




























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';
import ActivityCategories from '@/components/Activities/ActivityCategories.vue';

@Component({
	name: 'AgencyActivityCategorySettings',
  	components: { ActivityCategories, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getActivityCategories();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingActivityCategories;
  	}
}
